/**
 * Single source of truth for the 12 dashboard modules.
 *
 * Pillar-grouped order (Verify → Trace → Finance). Modules unlock
 * progressively driven by `ui.ModuleUnlocked` events accumulated in
 * `useSSE.modulesUnlocked`. T1 onboarding starts empty; T2/T3 returning
 * verified members start fully lit.
 *
 * Imported by:
 *   - frontend/lib/sse/useSSE.ts        (scenario.Started pre-population)
 *   - frontend/components/scene/Dashboard.tsx (rail rendering)
 *   - frontend/components/scenes/counterparts/TradeInProgressExporter.tsx
 *     (counterparty modules-lit mirror)
 */
export const ALL_MODULES = [
  "Profile",
  "GLEIF",
  "Counterparty",
  "Risk",
  "IdentityVerification",
  "CrossBorderCompliance",
  "TradePipeline",
  "Logistics",
  "ReconciliationDocs",
  "EInvoicing",
  "BillingAndInvoices",
  "ReconciliationSettlement",
] as const;

export type Module = (typeof ALL_MODULES)[number];
